import {
  ActionButton,
  ActionsGroup,
  Col,
  Panel,
  Row,
  SectionTitle,
  Table
} from '@elotech/components';
import { useState } from 'react';

import { ProtocoloBaseDTO } from '../../../../type';
import { InlineButton } from '../../../inline-button/InlineButton';
import { TableContainer } from '../../../table';
import { ProtocoloContainerPermissions } from '../../ProtocoloContainerBase';
import { ProcessoDigitalSelect } from './ProcessoDigitalSelect';

type Props = {
  processos?: ProtocoloBaseDTO[];
  onAddProcesso: (processoId: string, onLimparSelecao: () => void) => void;
  onMarcarPrincipal: (id: string) => void;
  onRemove: (id: string, onLimparSelecao: () => void) => void;
  permissions: ProtocoloContainerPermissions;
  entidadeProcessoDigital?: string;
};

export const ProcessoDigitalComponent = ({
  processos = [],
  onAddProcesso,
  onMarcarPrincipal,
  onRemove,
  permissions,
  entidadeProcessoDigital
}: Props) => {
  const [processoSelecionado, setProcessoSelecionado] = useState<string>();
  const { create: canAdd, update: canUpdate, delete: canDelete } = permissions;

  const onLimparSelecao = () => setProcessoSelecionado(undefined);

  const onAdicionar = () => {
    if (processoSelecionado) {
      onAddProcesso(processoSelecionado, onLimparSelecao);
    }
  };

  const onVisualizar = (processo: ProtocoloBaseDTO) => {
    if (processo.link) {
      window.open(processo.link, '_blank');
    }
  };

  const renderPesquisarProcessos = () =>
    canAdd && (
      <>
        <SectionTitle>Pesquisar Processos</SectionTitle>
        <Row>
          <Col md={6}>
            <Panel title="Processo Digital">
              <ProcessoDigitalSelect
                value={processoSelecionado}
                entidadeId={entidadeProcessoDigital}
                onChange={(value: string) => setProcessoSelecionado(value)}
              />
              <InlineButton
                label="Vincular Processo"
                icon="fa fa-plus"
                className="mt-xs"
                disabled={!processoSelecionado}
                onClick={onAdicionar}
              />
            </Panel>
          </Col>
        </Row>
      </>
    );

  return (
    <>
      {renderPesquisarProcessos()}
      <SectionTitle>Processos Vinculados</SectionTitle>
      <TableContainer>
        <Table values={processos || []}>
          <Table.Column
            name="numero"
            header="Número"
            value={(protocolo: ProtocoloBaseDTO) =>
              protocolo.numeroIdentificacao
            }
          />
          <Table.Column
            name="ano"
            header="Ano"
            value={(protocolo: ProtocoloBaseDTO) => protocolo.anoIdentificacao}
          />

          <Table.Column
            name="assunto"
            header="Assunto"
            value={(protocolo: ProtocoloBaseDTO) => protocolo.descricao}
          />

          <Table.Column
            name="situacaoProcesso"
            header="Situação"
            value={(processo: ProtocoloBaseDTO) => processo.situacaoProcesso}
          />
          <Table.Column
            name="tipoProcesso"
            header="Tipo"
            value={(processo: ProtocoloBaseDTO) => processo.tipoProcesso}
          />

          <Table.Column
            name="principal"
            header="Principal"
            value={(processo: ProtocoloBaseDTO) =>
              processo.principal ? 'Sim' : 'Não'
            }
          />
          <Table.Column
            header=""
            value={(processo: ProtocoloBaseDTO) => {
              return (
                <ActionsGroup>
                  {!processo.principal && canUpdate && (
                    <ActionButton
                      label="Marcar como principal"
                      icon="check"
                      onClick={() => onMarcarPrincipal(processo.id || '')}
                    />
                  )}
                  {processo.link && (
                    <ActionButton
                      label="Visualizar Processo"
                      icon="eye"
                      onClick={() => onVisualizar(processo)}
                    />
                  )}
                  {canDelete && (
                    <ActionButton
                      label="Excluir"
                      icon="trash"
                      onClick={() => onRemove(processo.id!, onLimparSelecao)}
                    />
                  )}
                </ActionsGroup>
              );
            }}
          />
        </Table>
      </TableContainer>
    </>
  );
};
